import { PilotJobOrderVersion as ServerPilotJobOrderVersion } from 'server/models/PilotJobOrderVersion';
import { PilotJobOrderVersionExtraDataData } from './PilotJobOrderVersionExtraData';
import { parseIfNonNull } from './ExtraDataUtils';

export { PilotJobOrderVersionData, PilotJobOrderVersionOptions } from 'server/models/PilotJobOrderVersion';

export class PilotJobOrderVersion extends ServerPilotJobOrderVersion {
    ExtraData() {
        return parseIfNonNull<PilotJobOrderVersionExtraDataData>(this.ExtraDataJSON());
    }
}



// WEBPACK FOOTER //
// ./data/models/PilotJobOrderVersion.ts